var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgManualVerificationIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 30,
  rx: 7,
  fill: "#5F1341"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 6C11.05 6 11.5 6.45 11.5 7C11.5 8.25 11.7003 9.45031 12.0703 10.5703C12.1801 10.9201 12.1 11.31 11.8203 11.5898L9.62012 13.79C11.0601 16.62 13.38 18.9299 16.21 20.3799L18.4102 18.1797C18.6101 17.9898 18.8602 17.8896 19.1201 17.8896C19.22 17.8897 19.3298 17.9005 19.4297 17.9404C20.5497 18.3104 21.76 18.5098 23 18.5098C23.5499 18.5098 23.9999 18.9599 24 19.5098V23C24 23.55 23.55 24 23 24C13.61 24 6 16.39 6 7C6 6.45 6.45 6 7 6H10.5ZM18.2002 21.21C19.4101 21.6099 20.6801 21.87 22 21.96V20.4697C21.23 20.4172 20.4677 20.2958 19.7197 20.1055L19.4004 20.0195L18.2002 21.21ZM8.03027 8C8.12027 9.31999 8.38004 10.59 8.79004 11.79L9.99023 10.5898C9.78027 9.86368 9.6386 9.10701 9.56641 8.33301L9.54004 8H8.03027Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgManualVerificationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/manual-verification-icon.cc211d8f22ae91253447345e5294ef87.svg";